export default "__VITE_ASSET__DN82FeMN__"